/**
 * Сколько сообщение может уехать за пройденное пальцем расстояние.
 *
 * Чем дальше палец уже уехал, тем тяжелее везти баббл дальше: сначала он едет
 * за пальцем 1:1, а к пределу хода сопротивление нарастает, и сколько ни тяни,
 * дальше limit сообщение не уедет.
 */
const easeDistance = (distance: number, limit: number): number => limit * (1 - Math.exp(-distance / limit));

/**
 * Сдвиг сообщения при свайпе влево.
 *
 * Смещение пальца dx (отрицательное — влево) превращаем в сдвиг сообщения.
 * Чем ближе к пределу хода maxOffset, тем сильнее сопротивление: сколько ни
 * тяни палец, сдвиг никогда не превысит maxOffset.
 *
 * @param {number} dx - смещение пальца по горизонтали за время жеста (px).
 * @param {number} maxOffset - предельный сдвиг сообщения (px).
 * @returns {number} - сдвиг сообщения (px), неположительный (влево).
 */
export const getElasticOffset = (dx: number, maxOffset: number): number => {
  // Защита от нулевого/отрицательного предела: деление на ноль дало бы NaN
  const limit = Math.max(1, maxOffset);

  // Учитываем только движение влево; свайп вправо (dx >= 0) хода не даёт
  const distance = Math.max(0, -dx);

  return -easeDistance(distance, limit);
};
